module.exports = __webpack_public_path__ + "static/swab-test-81bc1d8be659f1ac912f6796fb06eb1f.jpg";